import { ICreateSellerRequest } from 'models/auth'
import { ESellerTypes, ISellerCreateAuthForm } from 'models/seller'
import { normalizePhone } from 'shared/utils/normalizePhone'

// ИП и юрлицо приходят на бэкенд одним типом LEGAL, различает их DaData по ИНН
export const getSubmitData = (
  data: ISellerCreateAuthForm
): ICreateSellerRequest => ({
  type: ESellerTypes.LEGAL,
  name: data.firstName.trim(),
  surname: data.lastName.trim(),
  patronymic: data.middleName?.trim(),
  opt_otch: data.noMiddleName,
  tel: normalizePhone(data.phone),
  edo_operator: data.edoOperator?.trim(),
  edo_id: data.edoId?.trim(),
  legal_address: data.legalAddress?.trim(),
  legal_actual_address: data.actualAddress?.trim(),
  shop_name: data.shopName.trim(),
  INN: data.legalINN
})
